// Product billing-type options for the product management dialogs
export const Product_Type_Option = [
  {
    label: "One Time",
    value: "One Time",
  },
  {
    label: "Subscription",
    value: "Subscription",
  },
];
